// extracted by css-extract-rspack-plugin
export default {"modalConfirmBox":"modalConfirmBox___qnTxp","warnTitleMsg":"warnTitleMsg___Su4Kh","footBotton":"footBotton___2YQEi"};